import { checkOrganizationType } from '@/router/guards/check-organization-type';
import { checkServicesPagePermissions } from '@/router/guards/my-org-company.guards';
import type { RouteRecordRaw } from 'vue-router';

export default {
  path: 'org-company/:idElement',
  name: 'SicuraSolutionMyOrgCompany',
  component: () => import('@/views/private/MyOrgCompany.vue'),
  props: true,
  children: [
    {
      path: 'anagrafica',
      name: 'SicuraSolutionMyOrgCompanyAnagrafica',
      component: () => import('@/components/my-org-company/Anagrafica.vue'),
    },
    {
      path: 'sincronizzazione',
      name: 'SicuraSolutionMyOrgCompanySincronizzazione',
      component: () => import('@/components/my-org-company/sincronizzazione/Sincronizzazione.vue'),
    },
    {
      path: 'moduli',
      name: 'SicuraSolutionMyOrgCompanyModuli',
      component: () => import('@/components/my-org-company/Moduli.vue'),
    },
    {
      path: 'preferenze-corrispondenza',
      name: 'SicuraSolutionMyOrgCompanyPreferenzeCorrispondenza',
      component: () => import('@/components/my-org-company/PreferenzeCorrispondenza.vue'),
    },
    {
      path: 'tipologie-servizi',
      name: 'SicuraSolutionMyOrgCompanyTipologieServizi',
      component: () => import('@/components/my-org-company/TipologieServizi.vue'),
      beforeEnter: [checkServicesPagePermissions],
    },
    {
      path: 'associazione-fornitori',
      name: 'SicuraSolutionMyOrgCompanyAssociazioneFornitori',
      component: () => import('@/components/my-org-company/AssociazioneFornitori.vue'),
    },
    {
      path: 'funzionalita-aggiuntive',
      name: 'SicuraSolutionMyOrgCompanyFunzionalitaAggiuntive',
      component: () => import('@/components/my-org-company/FunzionalitaAggiuntive.vue'),
    },
    {
      path: 'qualifiche-fornitori',
      name: 'SicuraSolutionMyOrgCompanySupplierQualifications',
      component: () => import('@/components/my-org-company/SupplierQualifications.vue'),
    },
    {
      path: 'gestione-ras',
      name: 'SicuraSolutionMyOrgCompanyRasPurchase',
      component: () => import('@/components/my-org-company/RasPurchase.vue'),
    },
    {
      path: 'gestione-documentale-fornitori',
      name: 'SicuraSolutionMyOrgCompanyDocumentalePurchase',
      component: () => import('@/components/my-org-company/DocumentalePurchase.vue'),
    },
    {
      path: 'preferenze-email',
      name: 'SicuraSolutionMyOrgEmailPreferences',
      component: () => import('@/components/my-org-company/CustomEmail.vue'),
    },
  ],
  beforeEnter: [checkOrganizationType],
} as RouteRecordRaw;
